import { render, staticRenderFns } from "./UiIconChevronRight.vue?vue&type=template&id=72f18475"
var script = {}


/* normalize component */
import normalizer from "!../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports